import { InputLabel, TextField as MuiTextField, styled } from '@mui/material';

export const Wrapper = styled('div')(() => ({ width: '100%' }));

export const StyledTextField = styled(MuiTextField, {
  shouldForwardProp: (prop) => prop !== 'background' && prop !== 'error' && prop !== 'readOnly',
})<{
  background?: 'transparent' | 'white';
  error?: boolean;
  readOnly?: boolean;
}>(({ theme, background = 'transparent', error }) => ({
  '& .MuiOutlinedInput-root': {
    backgroundColor: error ? theme.palette.error.light : background === 'transparent' ? 'transparent' : theme.palette.common.white,
  },
  '& svg': {
    width: '20px',
  },
}));

export const StyledLabel = styled(InputLabel)({
  whiteSpace: 'wrap',
});
